import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonsService } from 'src/app/services/commons.service';
declare var document;

@Component({
  standalone: false,
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {

  dataAccess: any;
  showName: boolean;
  constructor(private readonly translation: TranslateService, private readonly c: CommonsService, private r: Router) { }

  ngOnInit() {
    document.querySelector('body').style.height = 'auto';
    this.showName = !window.location.href.includes('/faqs');
    this.translation.get(['FAQS.ANSWERS', 'FAQS.QUESTIONS']).subscribe(data => {
      this.dataAccess = data['FAQS.QUESTIONS'];
    });
  }

  datanicals(i) {
    this.c.eventsAnalitics('click', 'FAQs', i.value);
  }

  goToUrl = () => {
    this.r.navigateByUrl('home');
  }
}
